import { analytics } from "@/firebaseConfig";

export function logAnalyticsEvent(name, payload) {
  return analytics.logEvent(name, payload);
}
